import "./UnauthorizedModal.html";
import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { UnauthorizedModalComponentController } from "./UnauthorizedModalComponentController";

export class UnauthorizedModalComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = UnauthorizedModalComponentController;
        this.templateUrl = "/App/Modules/Auth/Components/LoginForm/UnauthorizedModal/UnauthorizedModal.html";
    }
}
